module.exports = __webpack_public_path__ + "static/media/grinder.db9e21bc.jpeg";